import angular from 'angular';
import { scopeLinkedPostsComponent } from './scopeLinkedPostsComponent';
import 'components/sharpr/api/apiModule';
import 'components/sharpr/taxonomy/taxonomyModule';

angular
	.module('sh.scopeLinkedPosts', ['sh.api', 'sh.taxonomy'])
	.component('shScopeLinkedPosts', scopeLinkedPostsComponent());
